<script setup lang="ts">
withDefaults(defineProps<{
  title: string;
  description?: string;
}>(), {
  description: "",
});
</script>

<template>
  <section class="rounded-[22px] border border-slate-200 bg-white p-4 dark:border-slate-700 dark:bg-slate-900 md:rounded-[24px] md:p-5">
    <div class="flex flex-col items-start gap-2 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h2 class="text-2xl font-bold text-slate-900 dark:text-white">{{ title }}</h2>
        <p v-if="description" class="mt-1 text-sm text-slate-600 dark:text-slate-300">
          {{ description }}
        </p>
      </div>
    </div>

    <div class="mt-4">
      <slot />
    </div>
  </section>
</template>
